import Icon from '../Icon/Icon';
import React, { useRef, useState } from 'react';
import Tooltip, { TooltipPosition } from '../Tooltip/Tooltip';
import styles from './IconButton.module.scss';
import PropTypes from 'prop-types';
import * as propTypes from 'prop-types';
import classNames from 'classnames';

const IconButton = ({
    icon,
    tooltip,
    onClick,
    ariaLabel,
    className,
    tooltipPosition = TooltipPosition.TOP_RIGHT,
    disabled = false,
}) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const buttonRef = useRef(null);

    const IconComponent = icon ? Icon[icon] : null;
    let finalAriaLabel = ariaLabel || tooltip;
    if (!finalAriaLabel && icon) {
        finalAriaLabel = `${icon} icon`;
    } else if (!finalAriaLabel) {
        finalAriaLabel = 'icon button';
    }

    const handleMouseEnter = () => {
        if (!disabled) {
            setShowTooltip(true);
        }
    };

    const handleMouseLeave = () => {
        setShowTooltip(false);
    };

    return (
        <button
            ref={buttonRef}
            type='button'
            className={classNames(styles.IconButton, {
                [styles.Disabled]: disabled,
                [className]: className,
            })}
            onClick={onClick}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onFocus={handleMouseEnter}
            onBlur={handleMouseLeave}
            disabled={disabled}
            aria-label={finalAriaLabel}
        >
            {IconComponent ? <IconComponent /> : null}
            {tooltip && !disabled && (
                <Tooltip
                    visible={showTooltip}
                    element={buttonRef.current}
                    position={tooltipPosition}
                    className={styles.Tooltip}
                >
                    {tooltip}
                </Tooltip>
            )}
        </button>
    );
};

IconButton.propTypes = {
    icon: propTypes.string.isRequired,
    tooltip: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    tooltipPosition: PropTypes.oneOf(Object.values(TooltipPosition)), // Ensure TooltipPosition exports its values
    ariaLabel: PropTypes.string,
};

export default IconButton;
